import * as tslib_1 from "tslib";
import { mutatorAction } from 'satcheljs';
import { lazyFindComposePlugins } from 'owa-mail-compose-store';
// The content change source for images moved from attachment well to message body
// Must be kept in sync with const in InlineImagePlugin.ts
var MOVEATTACHMENTTOINLINE_CHANGE_SOURCE = 'MoveAttachmentToInline';
export default mutatorAction('insertImageFromExistingInlineAttachment', function insertImageFromExistingInlineAttachment(composeViewState, contentId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            // Insert image (via ContentOperationPlugin -> InlineImagePlugin)
            lazyFindComposePlugins.import().then(function (findComposePlugins) {
                if (findComposePlugins) {
                    var composePlugins = findComposePlugins(composeViewState);
                    if (composePlugins && composePlugins.contentOperationPlugin) {
                        composePlugins.contentOperationPlugin.insertHtmlIntoEditor(createImageHtml(contentId), MOVEATTACHMENTTOINLINE_CHANGE_SOURCE);
                    }
                }
            });
            return [2 /*return*/];
        });
    });
});
function createImageHtml(contentId) {
    return '<img src="cid:' + contentId + '" />';
}
//# sourceMappingURL=insertImageFromExistingInlineAttachment.js.map